(function () {
    'use strict';
    angular.module('quantixApp').controller('EcoIndicatorsCompareController', EcoIndicatorsCompareController);

    EcoIndicatorsCompareController.$inject = ['$scope', 'GenericService', 'GenericServiceNew', 'EconomicIndicatorService', '$http', '$timeout', '$state', '$uibModal', '$filter', '$window', '$sce', 'AuthKeycloak', 'ivhTreeviewOptions', 'ivhTreeviewBfs'];

    function EcoIndicatorsCompareController($scope, GenericService, GenericServiceNew, EconomicIndicatorService, $http, $timeout, $state, $uibModal, $filter, $window, $sce, AuthKeycloak, ivhTreeviewOptions, ivhTreeviewBfs) {

        $scope.selectedSubCategories = [];
        $scope.subCategories = [];
        $scope.period = '1';
        $scope.porttoDate = '';
		$scope.portfromDate = '';
        $scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];
		$scope.startMaxDate = new Date();
		$scope.startMaxDate.setFullYear(new Date().getFullYear() - 10);
		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];
		$scope.showGraphs = false;
        $scope.endMaxDate = new Date();
        $scope.sameCategory = true;
        $scope.locationval = null;
		$scope.industryval = null;
		$scope.generateradio = true;
		var message = null;
		$scope.iferrorindustry = false;
		$scope.errorIndustryMessages = null;
		$scope.iferrorlocation = false;
		$scope.errorLocationMessages = null;
		$scope.iferrorcompname = false;
		$scope.errorcompnameMessage = null;
		$scope.iferrorpeerloc = false;
		$scope.errorpeerlocMessages = null;
		$scope.ParameterDTO = {};
        var idss = new Array();
		$scope.tempIndustryIdArr = [];
		$scope.tempIndustryNameArr = [];
		$scope.showValidationError = false;
		$scope.showError = false;

		$('#industrytreegrid').hide();
		$scope.ind = {
			indstatus : false
		};
		var click = 0;
		var locationGrid = null;
		var industryGrid = null;
		var locationGridpeer = null;
        $scope.childIds = [];
        
        $scope.selectedCategory = '0';
        $scope.loadingSharedCmpGraph = false;
        $scope.rebaseAndActualVal = 'actualVal';
		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};
		// Htmltreegrid data for location
		var clickloctree = 0;
		$scope.loc = {
			locstatus : false
		};
		
		$scope.showCompareTree = false;
		$scope.getLocationTree = function() {
			$('#industrytreegrid').hide();
		$scope.locationOptions = {
				dataProvider : $scope.zonalwiseLocationData,
				delegate : $scope
			};/* },100); */
			if (clickloctree == 0) {
				$timeout(function() {
					$("#loctree")[0].click();
				}, 100);
				clickloctree++;
			}
			$scope.locTreeData = $scope.zonalwiseLocationData;

			$scope.sampletreepeerdata = $scope.zonalwiseLocationData;

		}
		
		var locfiltervaluchanged = false;
		var firstcharloc = '';

		// Changes for relative industries dropdown

		$scope.filerPageSortHandleloc = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							locfiltervaluchanged = false;

						}
						if (!locfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharloc = filter.filterExpressions[0].expression
									locfiltervaluchanged = true;
									$scope
											.onLocationGridCreationCompleted(null);
								}
							}
						}
					}, 1);
		};

		$scope.onLocationGridCreationCompleted = function(event) {
			if (event != null) {
				locationGrid = event.target;
				locationGrid.enableHeightAutoAdjust = true;
				locationGrid.setSelectionMode("singleRow");
				locationGrid.validateNow();
			} else {
				locationGrid.enableHeightAutoAdjust = true;
				locationGrid.clearFilter();
				locationGrid.expandAll();
				locationGrid
						.setFilterValue('label', firstcharloc, locationGrid);
				locationGrid.validateNow();
			}

		};
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.onLocationDynamicLevelCreated = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		$scope.selectAllflag = false;
		$scope.selectAll = function(flag) {
			if(null != locationGrid){
				
				locationGrid.collapseAll();
				locationGrid.clearSelection();
				locationGrid.clearAllFilters();
				if (flag) {
					arrayloc = []
					$scope.selectedLocation = [];
					var allkeys = [];
					$scope.selectAllflag = true;
					ivhTreeviewBfs($scope.locTreeData, opts, function(node) {
						allkeys.push(node.id);
					});

					$timeout(function() {
						locationGrid.setSelectedKeys(allkeys, false);
					}, 100);

				} else {
					arrayloc = [];
					$scope.selectedLocation = [];
					$scope.selectAllflag = false;
					locationGrid.clearSelection();

				}
			}
			
		}

		var arrayloc = [];
		$scope.selectedLocation = [];
		$scope.badgeString = '';
		$scope.setbadgesforLocation = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {
				if (arrayloc != null && arrayloc != 'null') {
					arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
				}
				$scope.nolocdata = false;
				arrayloc.push(evt.item.label);
				$scope.locationval = arrayloc.length;
				if ($scope.locationval > 0) {
					$scope.iferrorlocation = false;
				}
			} else {
				arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
			}

			$timeout(
					function() {

						$scope.selectedLocation = angular.copy(arrayloc);
						$scope.badgeString = $scope.selectedLocation.toString();

//						if ($scope.badgeString.length > 30) {
//							for (var i = 0; i < $scope.selectedLocation.length; i++) {
//								if ($scope.selectedLocation[i].length > 10) {
//									$scope.selectedLocation[i] = $scope.selectedLocation[i]
//											.substr(0, 14)
//											+ '..';
//								}
//							}
							$scope.badgeString = $scope.selectedLocation
									.toString();
//						} else {
							$scope.badgeString = $scope.selectedLocation
									.toString();
					//	}
					}, 100);

		}
		// Htmltreegrid data for location end

		// Htmltreegrid data for industry
		$scope.ind = {
			indstatus : false
		};
		var click = 0;
		$scope.iterateChildren = function(node) {
			// if($scope.companyDetails.industryFiveDetail.split('_$$$$')[0] == node.id) {
			// 	if(!$scope.selectedIndustries.includes(node.label))
			// 		$scope.selectedIndustries.push(node.label);
			// 		//$scope.badgeStringind = $scope.selectedIndustries[0].substr(0,14);
			// 	$scope.badgeStringind = $scope.selectedIndustries[0];
			// } else if(node.children.length > 0) {
			// 	for (var index = 0; index < node.children.length; index++) {
			// 		const element = node.children[index];
			// 		$scope.iterateChildren(element);
			// 	}
			// }
		}
		$scope.getIndustryTree = function() {
			$('#locationtreegrid').hide();
			$scope.industryOptions = {
				dataProvider : $scope.subCategories,
				delegate : $scope
			};/* },100); */
			if (click == 0) {
				$timeout(function() {
					$("#getindtree")[0].click();
				}, 100);
				click++;
			}
			//if($scope.selectedIndustries.length == 0) {
				// ivhTreeviewBfs($scope.subCategories, opts, function(node) {
				// 	$scope.iterateChildren(node);
				// });
		
				// industryGrid.setSelectedObjects([{
				// 	id: $scope.companyDetails.industryFiveDetail.split('_$$$$')[0],
				// 	label: $scope.companyDetails.industryFiveDetail.split('_$$$$')[1]
				// }], false);
			//}
		}

		var indfiltervaluchanged = false;
		var firstcharind = '';

		$scope.filerPageSortHandle = function(event) {
			setTimeout(
					function() {

						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							indfiltervaluchanged = false;

						}else{
							grid.expandAll();
						}
						if (!indfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharind = filter.filterExpressions[0].expression
									indfiltervaluchanged = true;
									$scope
											.onindustryGridCreationCompleted(null);
								}
							}
						}
					}, 1);
		};


		$scope.disablelevelind = function(cell, data) {
			return data.children.length == 0;
		}

		$scope.disablecellind = function(cell, data) {
			return (cell.getLevel().getNestDepth() != 5);
		}

		$scope.disablecellloc = function(cell) {
			return (cell.getLevel().getNestDepth() != 3);
		}

		$scope.disablelevelloc = function(cell, data) {

			return !data.hasOwnProperty('children');
		}

		
		var firstTime = 0;
		$scope.onindustryGridCreationCompleted = function(event) {

			if (event != null) {
				industryGrid = event.target;
				industryGrid.enableHeightAutoAdjust = true;
				industryGrid.setSelectionMode("singleRow");
				industryGrid.validateNow();
			} else {
				industryGrid.enableHeightAutoAdjust = true;
				industryGrid.clearFilter();
				industryGrid.expandAll();
				industryGrid
						.setFilterValue('label', firstcharind, industryGrid);
				industryGrid.validateNow();
			}
			if(firstTime == 0) {
				ivhTreeviewBfs($scope.subCategories, opts, function(node) {
					$scope.iterateChildren(node);
				});
				var arr = [];
				arr.push($scope.selectedIndId)
				$timeout(function() {
					industryGrid.setSelectedKeys(arr, false);
				}, 100);
				if($scope.companyDetails != undefined){
				industryGrid.setSelectedObjects([{
					id: $scope.companyDetails.industryFiveDetail.split('_$$$$')[0],
					label: $scope.companyDetails.industryFiveDetail.split('_$$$$')[1]
				}], false);
			}
				firstTime = firstTime + 1;
			}
		};

		$scope.onIndustryDynamicLevelCreated = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		$scope.selectAllindustryflag = false;
		$scope.selectAllindustry = function(flag) {
			if(null != industryGrid){
				
				industryGrid.collapseAll();
				industryGrid.clearSelection();
				industryGrid.clearAllFilters();

				if (flag) {
					arrayind = []
					$scope.selectedIndustries = [];
					var allkeys = [];
					$scope.selectAllindustryflag = true;
					ivhTreeviewBfs($scope.subCategories, opts, function(node) {
						allkeys.push(node.id);
					});

					$timeout(function() {
						industryGrid.setSelectedKeys(allkeys, false);
					}, 100);

					industryGrid.setSelectedObjects($scope.subCategories, false);

				} else {
					//$scope.showGraphs=false;
					arrayind = [];
					$scope.idStack=[];
					$scope.selectedIndustries = [];
					$scope.childIds = [];
					$scope.selectAllindustryflag = false;
					industryGrid.clearSelection();
					indfiltervaluchanged = false;
					industryGrid.collapseAll();
					industryGrid.validateNow();
				}
			}
			
		}

		var arrayind = [];
		
		$scope.getChildIndustry = function(childArray) {
   				var childInd = [];
			if (childArray.children.length <= 0) {
				if($scope.idStack.indexOf(childArray.id) < 0){
				$scope.idStack.push(childArray.id);
				}
				if(!$scope.childIds.includes(childArray.id)) 
					$scope.childIds.push(childArray.id);
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					if($scope.idStack.indexOf(childArray.id) < 0){
						$scope.idStack.push(childArray.id);
						}
					$scope.getChildIndustry(childArr);
				}
			}

		}

		$scope.deleteChildIndustry = function(childArray) {
   				
			if (childArray.children.length <= 0) {
				var index = $scope.childIds.indexOf(childArray.id);
				if(arrayind.indexOf(childArray.label) > -1){
					arrayind.splice(arrayind.indexOf(childArray.label), 1)
					}
				if($scope.idStack.indexOf(childArray.id) > -1){
				$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
				}
				if (index > -1) {
					$scope.childIds.splice(index, 1);
					
				}
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					if($scope.idStack.indexOf(childArray.id) > -1){
						$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
						}
					if(arrayind.indexOf(childArray.label) > -1){
						arrayind.splice(arrayind.indexOf(childArray.label), 1)
						}
					$scope.deleteChildIndustry(childArr);
				}
			}

		}
		$scope.idStack = [];
			idss = new Array();
			var selectedIndArray = new Array();
			$scope.selectedIndss={};
			$scope.parentId ='';
			$scope.prevParentId = undefined;
		$scope.setbadgesforindustry = function(evt) {
			$scope.peerOneCompany = '';
			$scope.peerTwoCompany = '';
			$scope.peerThreeCompany = '';
			$scope.peerFourCompany = '';
			$scope.peerFiveCompany = '';

			
			var grid = evt.target;
			if (evt.isItemSelected) {

				$scope.noinddata = false;
				if (evt.item.children.length < 0) {
					arrayind.push(evt.item.label.replaceAll('&nbsp;',''));
					selectedIndArray.push(evt.item.label.replaceAll('&nbsp;',''));
				}else if(evt.item.parentId != 0){
					arrayind.push(evt.item.label.replaceAll('&nbsp;',''));
					selectedIndArray.push(evt.item.label.replaceAll('&nbsp;',''));
				}
				
				$scope.industryval = arrayind.length;
				if ($scope.industryval > 0) {
					$scope.iferrorindustry = false;
				}

				if (evt.item.children.length > 0) {
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						arrayind.push(childArr.label.replaceAll('&nbsp;',''));
						selectedIndArray.push(childArr.label.replaceAll('&nbsp;',''));
						var id = $scope.getChildIndustry(childArr);
		
						if($scope.idStack.indexOf(evt.item.id) < 0){
						$scope.idStack.push(evt.item.id);
						}
						if($scope.idStack.indexOf(childArr.id) < 0){
						$scope.idStack.push(childArr.id);
						}
						idss=$scope.idStack;
					}
				} else {
					//arrayind.push(evt.item.id);
					if($scope.idStack.indexOf(evt.item.id) < 0){
					//idss.push(evt.item.id);
						$scope.idStack.push(evt.item.id)
					}
					idss=$scope.idStack;
					if(!$scope.childIds.includes(evt.item.id)) 
						$scope.childIds.push(evt.item.id);
				}
			
				$scope.indFlag = false;
				console.log("event selected ",$scope.idStack);
			} else {
				if(arrayind.indexOf(evt.item.label.replaceAll('&nbsp;','')) > -1){
					arrayind.splice(arrayind.indexOf(evt.item.label.replaceAll('&nbsp;','')), 1);
				}
				
				if (evt.item.children.length > 0) {
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						arrayind.splice(arrayind.indexOf(childArr.label.replaceAll('&nbsp;','')), 1);
						var id = $scope.deleteChildIndustry(childArr);
						if($scope.idStack.indexOf(childArr.id) > -1){
						$scope.idStack.splice($scope.idStack.indexOf(childArr.id), 1);
						$scope.childIds.splice($scope.idStack.indexOf(childArr.id), 1);
						}
					
						
					}
					if($scope.idStack.indexOf(evt.item.id) > -1){
					$scope.idStack.splice($scope.idStack.indexOf(evt.item.id), 1);
					$scope.childIds.splice($scope.idStack.indexOf(evt.item.id), 1);
					}
					if($scope.idStack.length <=1){
						$scope.idStack=[];
					}
				} else {
					var index = $scope.childIds.indexOf(evt.item.id);
					if($scope.idStack.indexOf(evt.item.id) > -1){
					$scope.idStack.splice($scope.idStack.indexOf(evt.item.id), 1);
				}
					
					if(arrayind.indexOf(evt.item.label.replaceAll('&nbsp;','')) > -1){
						arrayind.splice(arrayind.indexOf(evt.item.label.replaceAll('&nbsp;','')), 1)
						}
					
					if (index > -1) 
						$scope.childIds.splice(evt.item.id, 1);
				}
				idss=$scope.idStack;
				
				console.log("event unselected selected ",$scope.idStack);
			}
			$scope.selectedIndId = evt.item.id;
			if($scope.childIds.length == 0){
				$scope.selectedIndustries = [];
				$scope.badgeStringindForDisplay=[];
			}
			$timeout(
					function() {

						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringindForDisplay = angular.copy(arrayind);
						$scope.badgeStringind = $scope.selectedIndustries
						.toString();
						grid.setSelectedKeys(idss, false);
						if ($scope.badgeStringind.length > 30) {
							for (var i = 0; i < $scope.badgeStringindForDisplay.length; i++) {
								if ($scope.badgeStringindForDisplay[i].length > 10) {
									$scope.badgeStringindForDisplay[i] = $scope.badgeStringindForDisplay[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringind = $scope.badgeStringindForDisplay
							.toString();
							
						} else {
							$scope.badgeStringind = $scope.badgeStringindForDisplay
									.toString();
						}

					}, 100);
		
			console.log($scope.childIds)
		}
		
		
		var clicklocpeer = 0;
		$scope.locpeer = {
			locstatuspeer : false
		};
		$scope.getLocationTreepeer = function(flag) {
			$scope.locpeer.locstatuspeer = true;

			/* $timeout(function(){ */$scope.locationOptionspeer = {
				dataProvider : $scope.zonalwiseLocationData,
				delegate : $scope
			};/* },100); */
			if (flag && clicklocpeer == 0) {
				$timeout(function() {
					$("#loctreepeer")[0].click();
				}, 100);
				clicklocpeer++;
			}
			$scope.locTreeDatapeer = $scope.zonalwiseLocationData;

			$scope.sampletreepeerdatapeer = $scope.zonalwiseLocationData;
		}

		$scope.validateSelections = function() {
			$scope.nocmpdata = false;
			$scope.nolocdata = false;
			$scope.noinddata = false;

			if ($scope.companyDetails.companyName == null
					|| $scope.companyDetails.companyName == "null"
					|| typeof $scope.companyDetails.companyName == "undefined"
					|| $scope.companyDetails.companyName.length == 0) {
				$scope.nocmpdata = true;
			}

			if (locationGrid.getSelectedKeys() == null
					|| locationGrid.getSelectedKeys() == "null"
					|| typeof locationGrid.getSelectedKeys() == "undefined"
					|| locationGrid.getSelectedKeys().length == 0) {
				$scope.nolocdata = true;
			}

			if (industryGrid.getSelectedKeys() == null
					|| industryGrid.getSelectedKeys() == "null"
					|| typeof industryGrid.getSelectedKeys() == "undefined"
					|| industryGrid.getSelectedKeys().length == 0) {
				$scope.noinddata = true;
			}

			if (($scope.nocmpdata || $scope.nolocdata || $scope.noinddata)) {
				$scope.iferror = true;
				$scope.errorMessages = "Please input company and select a industry and location.";

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 10000);
				return false;
			}

			return true;
		};
		// Htmltreegrid data for locationpeer end

		
		$scope.industryall = false;
		$scope.selectAllflagprod = false;
		$scope.selectAllflagloc = false;
		$scope.prodstatus = false;
		$scope.selectedsegmentsfinal = [];
		$scope.selectedProducts = [];

		var allKeysProducts = [];
		var allKeysInd = [];
		var arrayind = new Array();
		var arrayprod = new Array();
		var indgri = null;
		var prodgri = null;
		var indfiltervaluchanged = false;
		var firstcharind = '';
		var prodfiltervaluchanged = false;
		var firstcharprod = '';

		$scope.badgeStringInd = '';
		$scope.badgeStringProd = '';

		$scope.accrdn = {
			isopen : true
		};

		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};
		$scope.ind = {
			indstatus : false
		};

		$scope.prod = {
			prodstatus : false
		};


		$scope.onDynamicLevelCind = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onDynamicLevelCprod = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onGridCreationCompletedIndustry = function(event) {
			if (event != null) {
				indgri = event.target;
				indgri.enableHeightAutoAdjust = true;
				indgri.validateNow();
			} else {
				indgri.enableHeightAutoAdjust = true;
				indgri.clearFilter();
				indgri.setFilterValue('label', firstcharind, indgri);
				indgri.validateNow();
			}
		};


		var filterselectall = false;
		// for industry tree
		$scope.selectAllind = function(flag) {
			$scope.peerOneCompany = '';
			$scope.peerTwoCompany = '';
			$scope.peerThreeCompany = '';
			$scope.peerFourCompany = '';
			$scope.peerFiveCompany = '';
			allKeysInd = [];
			$scope.idStack =[];
			$scope.childIds = [];
			if (flag) {

				$scope.indFlag = false;
				$scope.noinddata = false;
				arrayind = [];
				$scope.selectedIndustries = [];
				if (indfiltervaluchanged) {
					filterselectall = true;
					$scope.industryall = false;
				} else {
					filterselectall = false;
					$scope.industryall = true;
				}

				ivhTreeviewBfs($scope.subCategories, opts, function(node) {
					if (indfiltervaluchanged) {
						if (node.label.toLowerCase().includes(firstcharind)) {
							$scope.selectedIndustries.push(node.label);
							allKeysInd.push(node.id);
							if (node.children.length > 0) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysInd.push(childnode.id);
									arrayind.push(node.label);
									
								});
							}
						}
					} else {
						$scope.idStack = allKeysInd;
						$scope.childIds =allKeysInd;
						arrayind.push(node.label);
						allKeysInd.push(node.id);
						$scope.tempIndustryIdArr.push(node.id);
					}
				});
				
				$scope.selectedIndustries = angular.copy(allKeysInd);
				$scope.badgeStringInd = $scope.selectedIndustries.toString();
				$timeout(function() {
					industryGrid.setSelectedKeys(allKeysInd, false);
				}, 100);
			} else {
				$scope.companyDetails.industryId='';
				arrayind = [];
				$scope.selectedIndustries = [];
				$scope.industryall = false;
				industryGrid.clearSelection();
				industryGrid.clearAllFilters();
				industryGrid.clearChanges();
				indfiltervaluchanged = false;
				industryGrid.collapseAll();
				industryGrid.validateNow();
				$scope.indFlag = true;
			}
		}

		$scope.ind.indstatus = false;
		var cnt = 0;

		$scope.setIndustryTree = function() {
			$scope.ind.indstatus = true;

			$scope.gridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};
			if (cnt == 0) {
				cnt = 1;
				$timeout(function() {
					var l = document.getElementById('industryButton');
					l.click();
				}, 100, false);
			}
		}

		$scope.selectedType = 'INDUSTRY';
		$scope.status = {
			open : true
		};

		$scope.setSelectedType = function(type) {
			$scope.showResult = false;

			if ($scope.selectedType != type) {
				if (type == 'INDUSTRY') {
					if (prodgri != null) {
						prodgri.clearSelection();
						$scope.selectedProducts = [];
						$scope.selectAllprodflag = false;
						allKeysProducts = [];
						allKeysInd = [];
						arrayind = new Array();
						arrayprod = new Array();
					}
				} else if (type == "PRODUCT") {
					if (indgri != null) {
						indgri.clearSelection();
						allKeysProducts = [];
						allKeysInd = [];
						$scope.selectedIndustries = [];
						$scope.industryall = false;
						arrayind = new Array();
						arrayprod = new Array();
					}
				}
				$scope.selectedType = type;
			}
		}
        $scope.checkSelectedSubCats = function() {
			var subCategoriesList = [];
			for (var index = 0; index < $scope.idStack.length; index++) {
                const element = $scope.idStack[index];
                if(element.indexOf('_') > 0) {
                    subCategoriesList.push(element);
                }
            }
			$scope.showValidationError = !(subCategoriesList.length >= 2 && subCategoriesList.length <= 5);
            return false;
        }

		$scope.filterDates = function() {
			if($scope.portfromDate != '' || $scope.porttoDate != '') {
				$scope.period = undefined;
				if($scope.portfromDate > $scope.porttoDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'From Date should be less than To Date';
				} else if($scope.portfromDate < $scope.startMaxDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'From Date should not exceed '+ $filter('date')($scope.startMaxDate,'dd-MMM-yyyy');
				} else if($scope.porttoDate > $scope.endMaxDate) {
					$scope.errorFilter = true;
					$scope.errorFilterMsg = 'To Date should not exceed ' + $filter('date')($scope.endMaxDate,'dd-MMM-yyyy');
				} else {
					$scope.errorFilter = false;
					$scope.period = undefined;
					$scope.plotGraph();
				}
			}
		}

		$scope.restFilter = function() {
			var d = new Date();
			d.setMonth(d.getMonth() - 6);
			$scope.portfromDate = d;
			$scope.porttoDate = new Date();
			$scope.fromDate = d;
			$scope.toDate = new Date();
		}
		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

        var gaugeChart = null;
		$scope.graphProperty = [{
			"valueAxis": "v1",
			"lineColor": "#d6002a",
			"valueField": "value0",
			"fillAlphas": 0,
			"lineThickness": 2
		}, {
			"valueAxis": "v1",
			"lineColor": "#FCD202",
			"title": "yellow line",
			"valueField": "value1",
			"fillAlphas": 0,
			"lineThickness": 2
		}, {
			"valueAxis": "v1",
			"lineColor": "#269807",
			"title": "green line",
			"valueField": "value2",
			"fillAlphas": 0,
			"lineThickness": 2
		}, {
			"valueAxis": "v1",
			"lineColor": "#0758A0",
			"title": "green line",
			"valueField": "value3",
			"fillAlphas": 0,
			"lineThickness": 2
		}, {
			"valueAxis": "v1",
			"lineColor": "#696969",
			"title": "green line",
			"valueField": "value4",
			"fillAlphas": 0,
			"lineThickness": 2
		}];
		localStorage.setItem('graphprop', JSON.stringify($scope.graphProperty));
        $scope.getAllSubCategories = function () {
            EconomicIndicatorService.getAllSubCategories().then(
                function (successData) {
                    $scope.subCategories = successData.data.masterhierarchy;
                    $scope.compareCategories = successData.data.compareCathierarchy;
                }, function (errorData) {
                    $scope.responseMessage = errorData.data;
                }
            );
        }

        $scope.filterPeriod = function () {
			if($scope.period) {
				$scope.portfromDate = $scope.porttoDate = '';
				$scope.plotGraph();
			}
		}

        $scope.compareGraph = function() {
            $scope.porttoDate = '';
			$scope.portfromDate = '';
			if($scope.showValidationError) {
				$scope.showError = true;
				$scope.showGraphs = false;
			} else {
				$scope.showError = false;
				$scope.plotGraph();
			}
        }
        
        $scope.plotGraph = function () {
            $scope.errorFilter = false;
            var compareList = [];
            var categoriesList = [];

           // $scope.addCompareAndSelectedCat();
            for (var index = 0; index < $scope.idStack.length; index++) {
                const element = $scope.idStack[index];
                if(element.indexOf('_') > 0) {
                    compareList.push({
                        selectedCategory: element.split("_")[1],
                        selectSubCategory: element.split("_")[0],
                        selectedPeriod: $scope.period,
                        fromDate: $scope.portfromDate,
                        toDate: $scope.porttoDate,
                        rebaseAndActualVal: $scope.rebaseAndActualVal
                    });
					categoriesList.push(element.split("_")[1]);
                }
            }
            var index = -1;
            categoriesList = _.uniq(categoriesList);
			index = _.indexOf(categoriesList, '3');
            $scope.showGraphs = true;
            $scope.categoryDenomination = [];
			
            EconomicIndicatorService.checkDenomination(compareList).then(
                function (successData) {
                    $scope.sameCategory = true;
                    if(successData.data.indexOf('twoDenomination') >= 0){
						if($scope.rebaseAndActualVal =='rebaseVal') {
							$scope.sameCategory = index == -1 ? true : false;
						} else {
							$scope.sameCategory = false;
						}
						$scope.categoryDenomination = successData.data.split('*')[1].split('#');
                    } else {
						$scope.categoryDenomination = successData.data.split('#');
					}
                    $scope.compare(compareList);
                }, function (errorData) {
                    $scope.sameCategory = false;
                    if(errorData.status == 412) {
                        $scope.errorFilter = true;
                        $scope.errorFilterMsg = 'The subcategories selected belong to different denominations. Please select only two subcategories of different denominations';
                    } else {
                        $scope.compare(compareList);
                    }
                    $scope.responseMessage = errorData.data;
                }
            );
            
        }
        $scope.showGraphFlagCmp = true;
        $scope.compare = function(compareList) {
        	$scope.loadingSharedCmpGraph = true;
			$scope.showGraphFlagCmp = false;
            EconomicIndicatorService.compareGraph(compareList).then(
                function (successData) {
                    $scope.graphData = successData.data;
                    if($scope.graphData.length  > 0){
                    	$scope.showGraphFlagCmp = true;
                    	$scope.errorFilter=false;
                    	$scope.errorFilterMsg = '';
                    	$scope.initGraph(compareList);
                }else{
                	$scope.showGraphFlagCmp = false;
                	$scope.errorFilter=true;
                	$scope.errorFilterMsg = "There is no data present for selected period."
                	
                }
                }, function (errorData) {
                    $scope.responseMessage = errorData.data;
                }
            );
        }

        $scope.initGraph = function (compareList) {
            var graphs = JSON.parse(localStorage.getItem('graphprop'));  
			graphs = graphs.slice(0, compareList.length);
			var denomObj = {};  
			for (var index = 0; index < $scope.categoryDenomination.length; index++) {
				const element = $scope.categoryDenomination[index];
				denomObj[element.split('$')[0]] = element.split('$')[1];
			}
			var compareOneGraph = compareList[1].selectSubCategory;
            for (var index = 0; index < compareList.length; index++) {
                const element = $scope.selectedIndustries[index];
                graphs[index].title = element + " ( " + denomObj[parseInt(compareList[index].selectedCategory)] + " )";
                if(!$scope.sameCategory && compareList[index].selectSubCategory != compareOneGraph ){
                	 graphs[index].valueAxis = 'categoryAxis';
                }
            }
			var config_same_denom = {
				"type": "serial",
				"theme": "none",
				"legend": {
					"useGraphSettings": true
				},
				"dataProvider": $scope.graphData,
				"synchronizeGrid":true,
				"valueAxes": [{
					"id":"v1",
					"axisColor": "#000",
					"axisThickness": 2,
					"axisAlpha": 1,
					"position": "left"
				}],
				"graphs": graphs,
				"chartScrollbar": {},
				"chartCursor": {
					"cursorPosition": "mouse",
					"cursorColor":"#000000"
				},
				"categoryField": "date",
				"categoryAxis": {
					"parseDates": true,
					"axisColor": "#DADADA",
					"minorGridEnabled": true,
					"dateFormats": [
						{ "period": "mm", "format": "JJ:NN" },
						{ "period": "hh", "format": "JJ:NN" },
						{
							"period": "DD",
							"format": "MMM DD"
						}, {
							"period": "WW",
							"format": "MMM DD"
						}, {
							"period": "MM",
							"format": "MMM YYYY"
						}, {
							"period": "YYYY",
							"format": "MMM YYYY"
						}],
				},
				"export": {
					"enabled": true,
					"position": "bottom-right"
				 }
			}
			// var config_same_denom = {
			// 	"type": "serial",
			// 	"theme": "none",
			// 	"autoMarginOffset": 20,
			// 	"marginRight": 80,
			// 	"dataProvider": $scope.graphData,
			// 	"valueAxes": [{
			// 		"id":"v1",
			// 		"axisColor": "#000",
			// 		"axisThickness": 2,
			// 		"axisAlpha": 1,
			// 		"position": "left"
			// 	}, {
			// 		"id": "indexAxis",
			// 		"axisAlpha": 0,
			// 		"gridAlpha": 0,
			// 		"position": "left"
			// 	}],

			// 	"graphs": graphs,
			// 	"chartCursor": {
			// 		"enabled": true,
			// 		"valueLineEnabled": false,
			// 		"valueLineAlpha": 0.5,
			// 		"valueLineBalloonEnabled": false,
			// 		"categoryBalloonEnabled": false,
			// 		"categoryLineEnabled": false,
			// 		"graphBulletAlpha": 1,
			// 		"balloonPointerOrientation": "vertical",
			// 		"cursorPosition": "mouse",
			// 		"cursorColor": "#000000",
			// 		"cursorAlpha": 1,
			// 		"zoomable": true
			// 	},
			// 	"categoryField": "date",
			// 	"categoryAxis": {
			// 		"equalSpacing ": true,
			// 		"parseDates": true,
			// 		"axisAlpha": 0,
			// 		"gridAlpha": 0,
			// 		"tickLength": 0,
			// 		"twoLineMode": true,
			// 		"dateFormats": [
			// 			{ "period": "mm", "format": "JJ:NN" },
			// 			{ "period": "hh", "format": "JJ:NN" },
			// 			{
			// 				"period": "DD",
			// 				"format": "DD MMM"
			// 			}, {
			// 				"period": "WW",
			// 				"format": "DD MMM"
			// 			}, {
			// 				"period": "MM",
			// 				"format": "MMM YYYY"
			// 			}, {
			// 				"period": "YYYY",
			// 				"format": "MMM YYYY"
			// 			}],
			// 		"gridThickness": 0,
			// 	},
			// 	"chartScrollbar": {
			// 		"scrollbarHeight": 40,
			// 		"backgroundAlpha": 0,
			// 		"selectedBackgroundAlpha": 0.1,
			// 		"selectedBackgroundColor": "#888888",
			// 		"graphFillAlpha": 0,
			// 		"graphLineAlpha": 0.5,
			// 		"selectedGraphFillAlpha": 0,
			// 		"selectedGraphLineAlpha": 1,
			// 		"autoGridCount": true,
			// 		"color": "#AAAAAA"
			// 	},
			// 	"balloon": {
			// 		"offsetX": 50,
			// 		"offsetY": 8,
			// 		"fixedPosition": false

			// 	},
			// 	"export": {
			// 		"enabled": true,
			// 		"position": "bottom-right"
			// 	}
			// };
            // var config_same_denom = {
            //     "type": "serial",
            //     "theme": "none",
            //     "legend": {
            //         "equalWidths": false,
            //         "useGraphSettings": true,
            //         "valueAlign": "left",
            //         "valueWidth": 120
            //     },
            //     "dataProvider": $scope.graphData,
            //     "valueAxes": [{
            //         "id": "indexAxis",
            //         "axisAlpha": 0,
            //         "gridAlpha": 0,
            //         "position": "left"
            //     }],
            //     "graphs": graphs,
                
            //     "chartCursor": {
            //         "categoryBalloonDateFormat": "DD-MMM-YYYY",
            //         "cursorAlpha": 0.1,
            //         "cursorColor":"#000000",
            //          "fullWidth":true,
            //         "valueBalloonsEnabled": false,
            //         "zoomable": true
            //     },
            //         "dataDateFormat": "YYYY-MM-DD",
            //     "categoryField": "date",
            //     "categoryAxis": {
            //         "dateFormats": [
            //         	{"period":"mm","format":"JJ:NN"},
			//     		{"period":"hh","format":"JJ:NN"},
            //         	{
            //             "period": "DD",
            //             "format": "MMM DD"
            //         }, {
            //             "period": "WW",
            //             "format": "MMM DD"
            //         }, {
            //             "period": "MM",
            //             "format": "MMM YYYY"
            //         }, {
            //             "period": "YYYY",
            //             "format": "MMM YYYY"
            //         }],
            //         "parseDates": true,
            //         "autoGridCount": true,
            //         "axisColor": "#555555",
            //         "gridAlpha": 0.1,
            //         "gridColor": "#FFFFFF",
            //         "gridCount": 50,
            //         "boldLabels":true
            //     }, "export": {
            //         "enabled": true,
            //         "position":"bottom-right"
                    
            //     }
            // };

            var config_diff_denom = {
				"type": "serial",
				"theme": "none",
				"legend": {
					"useGraphSettings": true
				},
				"dataProvider": $scope.graphData,
				"synchronizeGrid":true,
				"valueAxes": [{
					"id":"v1",
					"axisColor": "#000",
					"axisThickness": 2,
					"axisAlpha": 1,
					"position": "left"
				}, {
                    "id": "categoryAxis",
                    "axisAlpha": 0,
                    "gridAlpha": 0,
                    "position": "right"
                }],
				"graphs": graphs,
				"chartScrollbar": {},
				"chartCursor": {
					"cursorPosition": "mouse",
					"cursorColor":"#000000"
				},
				"categoryField": "date",
				"categoryAxis": {
					"parseDates": true,
					"axisColor": "#DADADA",
					"minorGridEnabled": true,
					"dateFormats": [
						{ "period": "mm", "format": "JJ:NN" },
						{ "period": "hh", "format": "JJ:NN" },
						{
							"period": "DD",
							"format": "MMM DD"
						}, {
							"period": "WW",
							"format": "MMM DD"
						}, {
							"period": "MM",
							"format": "MMM YYYY"
						}, {
							"period": "YYYY",
							"format": "MMM YYYY"
						}],
				},
				"export": {
					"enabled": true,
					"position": "bottom-right"
				 }
			}
            $scope.loadingSharedCmpGraph = true;
            if($scope.sameCategory) {
                gaugeChart = AmCharts.makeChart("chartDivBarChart", config_same_denom);
            } else {
                gaugeChart = AmCharts.makeChart("chartDivBarChart", config_diff_denom);
            }
            
			$scope.$on("downloadImages",function($event, message){
				gaugeChart["export"].capture({}, function() {
				    // SAVE TO PNG
				    this.toPNG({}, function(base64) {
				    	$scope.exportdata[$scope.id]=base64;
				    	$scope.$emit("imageextractedCapital",{'type':$scope.id,'base64':base64});
				    });
				});
			});
        }

	$scope.getAllCategories = function() {
		EconomicIndicatorService.getAllCategories().then(
			function(successData) {

                $scope.categories = [];
                angular.forEach(successData.data, function(value, key){
                    if(value.id != 9 && value.id != 5 && value.id != 15 && value.id != 14 && value.id != 16)
                    	$scope.categories.push(value);
                 });
           
			
			}, function (errorData) {
				$scope.responseMessage = errorData.data;
			 }
		);
    }
	$scope.frequency = 'Daily';
	$scope.updateCategories = function(){
	    //$scope.showGraphs = false;
		allKeysInd = [];
		$scope.idStack =[];
		$scope.childIds = [];
		$scope.loadingSharedCmpGraph = false;
		 $scope.rebaseAndActualVal = 'actualVal';
		$scope.showCompareTree = true;
		
		$scope.resetTimeframeFlags();


		$scope.badgeStringInd = ''
			arrayind = [];
			$scope.selectedIndustries = [];
			$scope.industryall = false;
			var compareList = [];
		 angular.forEach($scope.categoriesWiseFrequncy.data, function(val, key) {
	 		   
	 		   if(key == $scope.selectedCategory){
	 			   
	 			  $scope.frequency= val;
	 			   
	 		   }
	 				});
					 if($scope.frequency != 'Daily'){
						$scope.period = '1';
						}else{
							$scope.period = '180';
						}
		 $scope.updateTimeframe();


	 	 angular.forEach($scope.compareCategories, function(val, key) {
	 		   
	 		   if(key == $scope.selectedCategory){
	 			   
	 			  $scope.subCategories= val;
	 			   
	 		   }
	 				});
		
	}
	
	$scope.getCategoryWiseFrequency = function(){
		EconomicIndicatorService.getCategoryFrequency().then(
				function(successData) {
	                $scope.categoriesWiseFrequncy = successData;
				}, function (errorData) {
					$scope.responseMessage = errorData.data;
				 }
			);
		
	}
	
	$scope.resetTimeframeFlags = function() {
		$scope.oneWeekFlag = false;
		$scope.oneMonFlag = false;
		$scope.threeMonFlag = false;
		$scope.sixMonFlag = false;
		$scope.oneYearFlag = false;
		$scope.fiveYearFlag = false;
		$scope.tenYearFlag = false;
		$scope.threeYearFlag = false;
		$scope.twoYearFlag = false;
	}

	$scope.updateTimeframe = function() {
		if($scope.frequency == 'Daily'){
			$scope.oneWeekFlag = true;
			$scope.oneMonFlag = true;
			$scope.threeMonFlag = true;
			$scope.sixMonFlag = true;
		}
		if($scope.frequency == 'Weekly'){
			$scope.oneMonFlag = true;
			$scope.threeMonFlag = true;
			$scope.sixMonFlag = true;
			$scope.oneYearFlag = true;
		}
		if($scope.frequency == 'Fortnightly'){
			$scope.oneMonFlag = true;
			$scope.sixMonFlag = true;
			$scope.oneYearFlag = true;
			$scope.threeYearFlag = true;
		}
		if($scope.frequency == 'Monthly'){
			$scope.sixMonFlag = true;
			$scope.oneYearFlag = true;
			$scope.threeYearFlag = true;
			$scope.fiveYearFlag = true;
			
		}

	}
	
	$scope.onChildChange = function(vv){
		console.log(vv);
		if($scope.period){
			$scope.filterPeriod();
		}else{
			$scope.filterDates();
		}
	}
	
	$scope.getCategoryWiseFrequency();
	$scope.getAllCategories();
    $scope.getAllSubCategories();
    }
})();